// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fa8a251","732":"a7bc2613"}[chunkId] + ".chunk.js";
};